import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import { Link } from 'react-router-dom';
// import { FaUndo } from 'react-icons/fa';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';


export function NormalCard(props) {
    return (
        <Card style={{ backgroundColor: '#4D4D4D', borderColor: "#FFF4E0"}}>
          {/* <Card.Img variant="top" src="holder.js/100px180" /> */}
          <Card.Body>
            <Card.Title>{props.Title}</Card.Title>
            <Card.Text>
                <span className='NormalCard-Text'>Location: {props.Location}</span><br></br>
                <span className='NormalCard-Text'>Average Rating: {props.AvgRating}</span><br></br>
            </Card.Text>
            <Link to="/viewreview"><Button style={{ backgroundColor: '#B46060', borderColor: "#B46060"}}>More Details</Button></Link>
          </Card.Body>
        </Card>
      );
}

function DateConvert(month) {
  if (month === '01') {
    month = 'January'
  }
  else if (month === '02') {
    month = 'February'
  }
  else if (month === '03') {
    month = 'March'
  }
  else if (month === '04') {
    month = 'April'
  }
  else if (month === '05') {
    month = 'May'
  }
  else if (month === '06') {
    month = 'June'
  }
  else if (month === '07') {
    month = 'July'
  }
  else if (month === '08') {
    month = 'August'
  }
  else if (month === '09') {
    month = 'September'
  }
  else if (month === '10') {
    month = 'October'
  }
  else if (month === '11') {
    month = 'November'
  }
  else if (month === '12') {
    month = 'December'
  }
  return month
}

export function ReviewCard(props) {

  let year = props.Date.slice(2,4)
  let month = props.Date.slice(5,7)
  let finMonth = DateConvert(month)

  let day = props.Date.slice(8,10)

  var AvgRatingRounded = Number(props.AvgRating).toFixed(1)

  let P1FoodRating = ""
  var P2FoodRating = ""

  if (props.p1food.toString() === "-1") {
    P1FoodRating = "N/A"
  }
  
  if (props.p2food.toString() === '-1') {
    P2FoodRating = "N/A"
  }

  if (props.p2food.toString() !== "-1") {
    P2FoodRating = props.p2food +"/ 10"
  }

  if (props.p1food.toString() !== "-1") {
    P1FoodRating = props.p1food +"/ 10"
  }
    return (
      <div className="Review-Card">
    <Card  style={{backgroundColor: '#4D4D4D'}}>
      <Container>
        <Row>
          <Col className="ReviewCard-Col-Title">
          <strong><span>{props.Title}, <i>{props.Location}</i></span></strong>
          </Col>
          <Col xs={3}className="ReviewCard-Col-Date">
            <strong><span className='ReviewCard-Title-Date'>{day}/{month}/{year}</span></strong>
          </Col>
          <Col xs={2} className="ReviewCard-Col-Rating">
            <strong><span >{AvgRatingRounded}</span></strong>
          </Col>
        </Row>
      </Container>
      
      <Row>
        <Col>
          <div className="ReviewCard-Col-1">
          <br></br>
            <span className='ReviewCard-Review'>Shin's Review:</span><br></br>
            <span className='ReviewCard-Dot'>•</span>
            <span className='NormalCard-Text'>Coffee - {props.p1coffee}/10</span><br></br>
            <span className='ReviewCard-Dot'>•</span>
            <span className='NormalCard-Text'>Food - {P1FoodRating}</span><br></br>
            <span className='ReviewCard-Dot'>•</span>
            <span className='NormalCard-Text'>Location - {props.p1location}/10</span><br></br>
            <span className='ReviewCard-Dot'>•</span>
            <span className='NormalCard-Text'>Staff - {props.p1staff}/10</span><br></br><br></br>
            <i><span className='NormalCard-Text'>..."{props.p1comments}"</span></i>
            

          </div>
          <br></br>
        </Col>

        <Col>
          <div className="ReviewCard-Col-2">
          <br></br>

            <span className='ReviewCard-Review'>Tom's Review:</span><br></br>
            <span className='ReviewCard-Dot'>•</span>
            <span className='NormalCard-Text'>Coffee - {props.p2coffee}/10</span><br></br>
            <span className='ReviewCard-Dot'>•</span>
            <span className='NormalCard-Text'>Food - {P2FoodRating}</span><br></br>
            <span className='ReviewCard-Dot'>•</span>
            <span className='NormalCard-Text'>Location - {props.p2location}/10</span><br></br>
            <span className='ReviewCard-Dot'>•</span>
            <span className='NormalCard-Text'>Staff - {props.p2staff}/10</span><br></br><br></br>
            <i><span className='NormalCard-Text'>..."{props.p2comments}"</span></i><br></br>

          </div>
          <br></br>

          </Col>
      </Row>
      {/* <ListGroup>
        <ListGroup.Item className='ReviewCard-Rating' style={{ backgroundColor: '#FFF4E0 '}}><span className='ReviewCard-Rating-Text'><i>Overall Rating: {props.AvgRating}/10</i></span></ListGroup.Item>
      </ListGroup> */}
      {/* <Card.Body> */}
        {/* <Card.Text>
          <Row xs={1} md={2} className="g-4">
            <Col>
            <span className='NormalCard-Text'>Tom's Coffee Rating: {props.p1coffee}</span><br></br>
            <span className='NormalCard-Text'>Tom's Food Rating: {props.p1food}</span><br></br>
            <span className='NormalCard-Text'>Tom's Location Rating: {props.p1location}</span><br></br>
            <span className='NormalCard-Text'>Tom's Staff Rating: {props.p1staff}</span><br></br>
            <span className='NormalCard-Text'>Tom's Comments: {props.p1comments}</span><br></br>
            </Col>

          </Row>

            <span className='NormalCard-Text'>Shin's Coffee Rating: {props.p2coffee}</span><br></br>
            <span className='NormalCard-Text'>Shin's Food Rating: {props.p2food}</span><br></br>
            <span className='NormalCard-Text'>Shin's Location Rating: {props.p2location}</span><br></br>
            <span className='NormalCard-Text'>Shin's Staff Rating: {props.p2staff}</span><br></br>
            <span className='NormalCard-Text'>Shin's Comments: {props.p2comments}</span><br></br>
            <span className='NormalCard-Text'>Overall Rating: {props.AvgRating}</span><br></br>
        </Card.Text> */}
        
      {/* </Card.Body> */}

    </Card>
    </div>
  );  
}
export default NormalCard